const isLoggedIn = (state) => !!state.userStore.sessionId;
const isAdmin = (state) => state.userStore.userType === "admin";

const shopMode = (state) => {
  return state.shopMode;
};

const userData = (state) => {
  return state.userData;
};

const reOrder = (state) => {
  return state.reOrder;
};

const appData = (state) => {
  return state.appData;
};

const addressRegistration = (state) => {
  return state.addressRegistration.state;
};
export default {
  isLoggedIn,
  isAdmin,
  shopMode,
  userData,
  reOrder,
  addressRegistration,
  appData,
};
